export const seCeCopy = {
  termsText: 'Terms of Service',
  termsUrl: 'https://www.veeqo.com/terms-of-service',
  privacyText: 'Privacy Notice',
  privacyUrl: 'https://www.veeqo.com/privacy',
  securityText: 'Security',
  securityUrl: 'https://www.veeqo.com/security',
  inlineProgress: 'Setting things up... this may take a few seconds',
  progress: 'Setting things up... this may take a few seconds',
  marketingSubtitleText: ["Amazon's", 'Free', 'Shipping and Inventory Management Software'],
  inlineSubtitleText: "Setting up Veeqo, Amazon's free shipping and inventory management software",
  subtitleText: ['Continuing to Veeqo', "Amazon's free shipping and inventory management software"],
  copyrightText: (year: number) => `© ${year} Veeqo Ltd P.O. Box 81226, Seattle, WA 98108-1226`,
};
